import { hasPermission } from '@/hooks/useBackendMenu'
import { parseDataTransform } from '@acme/common'
import Dialog from 'global/guides/Dialog'
import ConfirmarExclusao from 'global/guides/Dialog/ConfirmarExclusao'
import React from 'react'
import { useNavigate, useOutletContext, useParams } from 'react-router-dom'
import { Empresa, empresas } from 'service/api'
import { toast } from 'sonner'
import { useStore } from 'store'
import { DadosCadastrais } from '../atoms/forms/DadosCadastrais'

export default function DetalhesEmpresa() {
    const [excluir, setExcluir] = React.useState(false)

    const setEmpresaStore = useStore(state => state.setCompanyId)

    const navigate = useNavigate()
    const { empresaId } = useParams()

    const { data } = useOutletContext<{ data?: Empresa[] }>()
    const empresa = data?.find(item => item.id == Number(empresaId))

    const { mutate, isLoading } = empresas.mutations.useSoftDelete({
        invalidateQuery: true,
    })

    const toggleExcluir = () => {
        setExcluir(!excluir)
    }

    function handleBack() {
        navigate(-1)
    }

    function handleSubmit() {
        mutate(
            { id: empresa?.id! },
            {
                onSuccess: async () => {
                    toast.success('Empresa removida com sucesso!')

                    setEmpresaStore(-1)

                    handleBack()
                },

                onError: () => {
                    toast.error('Erro ao remover empresa')
                },
            },
        )
    }

    if (!empresa) return null

    return (
        <>
            <Dialog.Root
                onClose={handleBack}
                onSubmit={toggleExcluir}
                disableFields
                defaultValues={{
                    ...parseDataTransform(empresa, {
                        dateFormat: 'toString',
                    }),
                    uf: empresa.Cidade?.uf,
                    competenciaAtual: empresa.competenciaAtual,
                }}
            >
                <Dialog.Title>Detalhes da empresa</Dialog.Title>
                <Dialog.Content>
                    <DadosCadastrais />
                </Dialog.Content>
                <Dialog.Actions>
                    <Dialog.Actions.SecondaryButton />
                    {hasPermission(['delete', 'Empresas'], () => (
                        <Dialog.Actions.PrimaryButton color="error">
                            Excluir
                        </Dialog.Actions.PrimaryButton>
                    ))}
                </Dialog.Actions>
            </Dialog.Root>

            <ConfirmarExclusao
                width="md"
                open={excluir}
                onClose={toggleExcluir}
                loading={isLoading}
                onConfirm={handleSubmit}
                fecharAoConfirmar={false}
                title="Você tem certeza que deseja excluir esta empresa?"
            />
        </>
    )
}
